
import React, { useState, useEffect } from "react";
import Axios from "axios";
import { API_BASE_URL, GET_PO_REQ_BY_ID } from '../../../Config';
import PropTypes from 'prop-types';

const ViewPurchaseRequest = ({ tranViewObj }) => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [tranData, setTranData] = useState([]);
    const [firstData, setFirstData] = useState(null);
    const [formattedDate, setFormattedDate] = useState('');
    const [poDetailsLoading, setPODetailsLoading] = useState(false);

    // #region session userdetails
    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");

        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId, tranViewObj.PurchaseId) {
            setPODetailsLoading(true);
            Axios.get(`${API_BASE_URL}${GET_PO_REQ_BY_ID}?OrgId=${userDataSession.OrgId}&PurchaseId=${tranViewObj.PurchaseId}`)
                .then((response) => {
                    setPODetailsLoading(false);
                    setTranData(response.data.ResultData);
                    setFirstData(response.data.ResultData[0]);
                    console.log(response.data.ResultData)
                })
                .catch((error) => {
                    setPODetailsLoading(false);
                    console.error("Error fetching stores:", error);
                });
        }
    }, [userDataSession, tranViewObj]);


    useEffect(() => {
        if (tranViewObj && tranViewObj.RequestDate) {
            const poDate = new Date(tranViewObj.RequestDate);
            const formatted = poDate.toISOString().split('T')[0];
            setFormattedDate(formatted);
        }
    }, [tranViewObj]);

   
    return (
        <div>
            {/*view offcanvas */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightPRView"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "300px", maxWidth: "40%" }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">View Purchase Request (PR-{firstData && firstData.AutoGenTransactionNo})</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <div className="car">
                        <div className="card-bod">
                            <form>
                                <div className="row">
                                    <div className="col-lg-4 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label className="form-label">Supplier</label>
                                            <div className="row">
                                                <div className="col-lg-12 col-sm-12 col-12">
                                                    <input
                                                        className='form-control'
                                                        value={tranViewObj?.SupplierName}
                                                        style={{ cursor: 'not-allowed' }}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Date</label>
                                            <div className="input-groupicon">
                                                <input 
                                                    className='form-control' 
                                                    type='date'
                                                    value={formattedDate}
                                                    style={{ cursor: 'not-allowed' }}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Store</label>
                                            <input  
                                                className='form-control'
                                                value={tranViewObj?.StoreName}
                                                style={{ cursor: 'not-allowed' }}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="input-blocks">
                                            <label className="form-label">Notes</label>
                                            <input 
                                                type="text" 
                                                className='form-control'  
                                                name='Notes'
                                                value={firstData && firstData.Notes}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive no-pagination" style={{ maxHeight: '20rem', overflowY: 'auto' }}>
                                    <table className="table datanew">
                                        <thead className="sticky-top">
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Quantity</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {poDetailsLoading ? (
                                                <tr>
                                                    <td colSpan="12" className='text-center'>Loading...</td>
                                                </tr>
                                                ) : (
                                                tranData && tranData?.map((prod, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{prod.ProductName}</td>
                                                        <td>
                                                            <input
                                                                type='number'
                                                                className='form-control'
                                                                style={{ width: '10rem' }}
                                                                value={prod.Quantity}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-lg-12 text-end">
                                        <button
                                            type="button"
                                            className="btn btn-cancel add-cancel me-3"
                                            data-bs-dismiss="offcanvas"
                                            aria-label="Close"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                
    )
}

ViewPurchaseRequest.propTypes = {
    tranViewObj: PropTypes.object.isRequired,
};

export default ViewPurchaseRequest